
import { Component, Vue } from "vue-property-decorator";
import LoginModel from "@/models/LoginModel";
import User from "@/models/User";
import LoginService from "@/services/LoginService";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import IframeCommunicatorService, {
  InterPagesMessages,
  MessageTypes,
} from "@/services/IframeCommunicatorService";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import { Getter } from "vuex-class";
import GlobalConfig from "@/GlobalConfig";
import { newGuid } from "@microsoft/applicationinsights-core-js";
import Cookies from "js-cookie";
import VueRecaptcha from "vue-recaptcha";
import AfiliadoService from "@/services/AfiliadoService";

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    VueRecaptcha,
  },
})
export default class Login extends Vue {
  public currentYear = new Date().getFullYear();
  public loginModel = new LoginModel();
  public loginService = new LoginService();
  public loading = false;
  public showComunicationError = false;
  public showLoginError = false;
  public loginMessage = "";
  public iframeService = new IframeCommunicatorService();
  public userIsLoggedIn = false;
  public showCaptchaMessage: boolean = false;
  public captchaToken: string = "";
  public userIpAddress: string = null;
  public afiliadoService = new AfiliadoService();
  public showPassword = false;

  public togglePassword() {
    this.showPassword = !this.showPassword;
  }
  @Getter("user") user: User;

  mounted() {
    var html = document.getElementsByTagName("html");
    for (var i = 0; i < html.length; i++) {
      html[i].style.overflow = "visible";
    }
    this.userIsLoggedIn = this.$route.query.invalidUser === "true";
  }
  public goRecuperarClave() {
    this.$router.push("/cambio-password");
  }
  // public loginUser() {
  //   (this.$refs.form as VeeValidateForm).validate().then((isValid: boolean) => {
  //     if (isValid) {
  //       this.loading = true;
  //       this.showComunicationError = false;
  //       this.showLoginError = false;
  //       let submittedCedula = this.loginModel.userIdentity;
  //       let submittedPassword = this.loginModel.password;

  //       let sessionId = Cookies.get('sid')
  //         ? (this.$route.query.sessionId as string)
  //         : this.uuidv4();
  //       this.loginModel.sessionId = sessionId;

  //       this.loginService
  //         .login(this.loginModel)
  //         .then(async (response) => {
  //           const payload = response.data.payload;

  //           if (payload.code === 200 && payload.success) {
  //             const user = payload.entity;
  //             user.cedula = submittedCedula;
  //             user.password = submittedPassword;
  //             user.TokenGenerate = payload.tokenUser;
  //             user.userIdentityEncrypt = payload.userIdentityEncrypt;
  //             this.$store.dispatch("setUserLoggedAction", user);
  //             this.$store.dispatch("setSessionId", sessionId);
  //             var redirectObj = this.applyRedirect(user.esAfiliado);
  //             if (user.esAfiliado) {
  //               // var userJson = JSON.stringify({
  //               //   username: submittedCedula,
  //               //   password: submittedPassword,
  //               //   redirectUrl: redirectObj.redirectUrl,
  //               //   isLocalRedirect: redirectObj.isLocalRedirect,
  //               // });
  //               // var jsonEncoded = btoa(userJson);
  //               // this.iframeService.postMessageToParent(
  //               //   new InterPagesMessages(
  //               //     MessageTypes.AfiliadoSignIn,
  //               //     jsonEncoded
  //               //   )
  //               // );
  //             } else {
  //               const userName = `${user.primerNombre} ${user.primerApellido}`;
  //               const dataNoAfiliadoSignIn = {
  //                 username: userName,
  //                 redirectUrl: redirectObj.redirectUrl,
  //                 isLocalRedirect: redirectObj.isLocalRedirect,
  //               };
  //               const dataJson = JSON.stringify(dataNoAfiliadoSignIn);
  //               const jsonEncoded = btoa(dataJson);
  //               this.iframeService.postMessageToParent(
  //                 new InterPagesMessages(
  //                   MessageTypes.NoAfiliadoSignIn,
  //                   jsonEncoded
  //                 )
  //               );
  //             }

  //           }else if (payload.code === 220) {
  //             this.loginMessage =
  //               "Usuario o contraseña incorrecta, por favor verifique.";
  //             this.showLoginError = true;
  //             this.loading = false;
  //           } else {
  //             this.showComunicationError = true;
  //             this.loading = false;
  //           }
  //         })
  //         .catch((e) => {
  //           console.error(e);
  //           this.$store.dispatch("setUserLoggedAction", null);
  //           this.showComunicationError = true;
  //           this.loading = false;
  //         })
  //         .finally(() => {
  //           this.loading = false;
  //         });
  //     }
  //   });
  // }
  public onCaptchaSuccess(token: any) {
    this.captchaToken = token;
  }

  public onCaptchaExpire() {
    this.captchaToken = "";
  }

  public validateCaptcha() {
    this.showCaptchaMessage = true;
  }

  get isCaptchaValid(): boolean {
    return this.captchaToken.length > 0;
  }

  // public async loginUser() {

  //   (this.$refs.form as VeeValidateForm).validate().then((isValid: boolean) => {
  //     if (isValid) {
  //       this.loading = true;
  //       this.showComunicationError = false;
  //       this.showLoginError = false;

  //       const submittedCedula = this.loginModel.userIdentity;
  //       const submittedPassword = this.loginModel.password;
  //       if (!this.isCaptchaValid) {
  //         this.validateCaptcha();
  //         this.loading = false;
  //         return;
  //       }
  //             this.userIpAddress = (await this.afiliadoService.getUserIpAddress()).data.ip;

  //       this.loginService.getUuidV4Id()
  //         .then((response) => {
  //            const sessionId = response.data.sessionId !== null && response.data.sessionId !== undefined
  //           ? response.data.sessionId
  //           : this.uuidv4();
  //           this.loginModel.sessionId = sessionId;
  //           this.loginModel.captchaToken = this.captchaToken;

  //           return this.loginService.login(this.loginModel);
  //         })
  //         .then(async (response) => {
  //           const payload = response.data.payload;

  //           if (payload.code === 200 && payload.success) {
  //             const user = payload.entity;
  //             user.cedula = submittedCedula;
  //             user.password = submittedPassword;
  //             user.TokenGenerate = payload.tokenUser;
  //             user.userIdentityEncrypt = payload.userIdentityEncrypt;

  //             this.$store.dispatch("setUserLoggedAction", user);
  //             this.$store.dispatch("setSessionId", this.loginModel.sessionId);

  //             const redirectObj = this.applyRedirect(user.esAfiliado);

  //             if (!user.esAfiliado) {
  //               const userName = `${user.primerNombre} ${user.primerApellido}`;
  //               const dataNoAfiliadoSignIn = {
  //                 username: userName,
  //                 redirectUrl: redirectObj.redirectUrl,
  //                 isLocalRedirect: redirectObj.isLocalRedirect,
  //               };
  //               const jsonEncoded = btoa(JSON.stringify(dataNoAfiliadoSignIn));
  //               this.iframeService.postMessageToParent(
  //                 new InterPagesMessages(MessageTypes.NoAfiliadoSignIn, jsonEncoded)
  //               );
  //             }
  //           } else if (payload.code === 220) {
  //             this.loginMessage = "Usuario o contraseña incorrecta, por favor verifique.";
  //             this.showLoginError = true;
  //           } else {
  //             this.showComunicationError = true;
  //           }
  //         })
  //           .catch((error) => {
  //         const status = error?.message;
  //             console.error("Error during login:", status);
  //         if (status && status.includes("Request failed with status code 401")) {
  //           console.warn("Acceso denegado por origen no permitido.");
  //           this.loginMessage = "No tienes permiso para acceder desde este sitio.";
  //         } else {
  //           console.error("Error durante login:", error);
  //           this.loginMessage = "Ocurrió un error al procesar el inicio de sesión.";
  //         }

  //         this.showLoginError = true;
  //         this.$store.dispatch("setUserLoggedAction", null);
  //       })
  //         .finally(() => {
  //           this.loading = false;
  //           (this.$refs.recaptcha as any)?.reset();
  //           this.captchaToken = "";
  //         });
  //     }
  //   });
  // }
  public async loginUser() {
    const isValid = await (this.$refs.form as VeeValidateForm).validate();

    if (isValid) {
      this.loading = true;
      this.showComunicationError = false;
      this.showLoginError = false;

      const submittedCedula = this.loginModel.userIdentity;
      const submittedPassword = this.loginModel.password;

      if (!this.isCaptchaValid) {
        this.validateCaptcha();
        this.loading = false;
        return;
      }

      try {
        this.loginModel.userIpAddress = (
          await this.afiliadoService.getUserIpAddress()
        ).data.ip;
        this.loginModel.captchaToken = this.captchaToken;
        const response = await this.loginService.getUuidV4Id();
        const sessionId =
          response.data.sessionId !== null &&
          response.data.sessionId !== undefined
            ? response.data.sessionId
            : this.uuidv4();
        this.loginModel.sessionId = sessionId;
        const loginResponse = await this.loginService.login(this.loginModel);
        const payload = loginResponse.data.payload;

        if (payload.code === 200 && payload.success) {
          const user = payload.entity;
          user.cedula = submittedCedula;
          user.password = submittedPassword;
          user.TokenGenerate = payload.tokenUser;
          user.userIdentityEncrypt = payload.userIdentityEncrypt;

          this.$store.dispatch("setUserLoggedAction", user);
          this.$store.dispatch("setSessionId", this.loginModel.sessionId);

          const redirectObj = this.applyRedirect(user.esAfiliado);

          if (!user.esAfiliado) {
            const userName = `${user.primerNombre} ${user.primerApellido}`;
            const dataNoAfiliadoSignIn = {
              username: userName,
              redirectUrl: redirectObj.redirectUrl,
              isLocalRedirect: redirectObj.isLocalRedirect,
            };
            const jsonEncoded = btoa(JSON.stringify(dataNoAfiliadoSignIn));
            this.iframeService.postMessageToParent(
              new InterPagesMessages(MessageTypes.NoAfiliadoSignIn, jsonEncoded)
            );
          }
        } else if (payload.code === 220) {
          this.loginMessage =
            "Usuario o contraseña incorrecta, por favor verifique.";
          this.showLoginError = true;
        } else {
          this.showComunicationError = true;
        }
      } catch (error: any) {
        const status = error?.message;
        console.error("Error during login:", status);

        if (status && status.includes("Request failed with status code 401")) {
          console.warn("Acceso denegado por origen no permitido.");
          this.loginMessage =
            "No tienes permiso para acceder desde este sitio.";
        } else {
          this.loginMessage =
            "Ocurrió un error al procesar el inicio de sesión.";
        }

        this.showLoginError = true;
        this.$store.dispatch("setUserLoggedAction", null);
      } finally {
        this.loading = false;
        (this.$refs.recaptcha as any)?.reset();
        this.captchaToken = "";
      }
    }
  }

  public uuidv4(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  public applyRedirect(userEsAfiliado: boolean): {
    redirectUrl: string;
    isLocalRedirect: boolean;
  } {
    var redirectUrl = "";
    var isLocalRedirect = true;
    debugger;
    console.log("es afiliado Login" + userEsAfiliado);
    if (!userEsAfiliado) {
      this.$router.push("/solicitudes-beneficiario");
      return { redirectUrl, isLocalRedirect };
    }

    if (this.$route.query.redirectPage) {
      redirectUrl = this.$route.query.redirectPage as string;
      isLocalRedirect = true;
      this.$router.push(redirectUrl);
    }

    if (this.$route.query.redirectToSiembra) {
      redirectUrl = this.$route.query.redirectToSiembra as string;
      isLocalRedirect = false;
      this.$router.push(redirectUrl);
    }

    // Si es afiliado y no se especifica ReturnUrl, mandar a default
    if (!redirectUrl) {
      // window.location.href = GlobalConfig.PORTAL_BASE_URL;
      // redirectUrl = "/default.aspx";
      // isLocalRedirect = false;
      this.$router.push("/Dashboard");
    }

    redirectUrl = redirectUrl || "/Dashboard";

    return { redirectUrl, isLocalRedirect };
    // if (isLocalRedirect) {
    //   this.$router.push(redirectUrl);
    // } else {
    //   this.iframeService.postMessageToParent(
    //               new InterPagesMessages(
    //                 MessageTypes.Redirect,
    //                 redirectUrl
    //               )
    //             );
    // }
  }
  public redirectHome() {
    window.location.href = GlobalConfig.PUBLIC_WEB_URL;
  }
}
